var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 5.83333L11.3238 6.28421C9.31052 7.62379 6.68981 7.62379 4.67649 6.28421L4.00016 5.83333M7.33349 14.5H8.66683C10.5306 14.5 11.4625 14.5 12.1976 14.1955C13.1777 13.7895 13.9564 13.0108 14.3623 12.0307C14.6668 11.2956 14.6668 10.3638 14.6668 8.5C14.6668 6.63623 14.6668 5.70435 14.3623 4.96927C13.9564 3.98915 13.1777 3.21046 12.1976 2.80448C11.4625 2.5 10.5306 2.5 8.66683 2.5H7.3335C5.46973 2.5 4.53785 2.5 3.80276 2.80448C2.82265 3.21046 2.04395 3.98915 1.63798 4.96927C1.3335 5.70435 1.3335 6.63623 1.3335 8.5C1.3335 10.3638 1.3335 11.2956 1.63798 12.0307C2.04395 13.0108 2.82265 13.7895 3.80276 14.1955C4.53785 14.5 5.46973 14.5 7.33349 14.5Z",
    stroke: "#6E707A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export default ForwardRef;